// Canvas Helper Functions
import { POSE_CONNECTIONS } from "@mediapipe/pose";
import { drawLandmarks, drawConnectors } from "@mediapipe/drawing_utils";


function newImage(src) {
  let _fetch = fetch(src);
  let _blob = _fetch.then((resp) => resp.blob());
  let _imgBmp = _blob.then((blob) => createImageBitmap(blob));

  return _imgBmp;  
}

function objectCollision(x1, y1, w1, h1, x2, y2, w2, h2) {
  if (x2 > x1 + w1 || x2 + w2 < x1 || y2 > y1 + h1 || y2 + h2 < y1) {
    return false;
  } else {
    return true;
  }
}

function drawLoading(canvasCtx, frameCount) {
  canvasCtx.save();

  canvasCtx.translate(canvasCtx.canvas.width / 2, canvasCtx.canvas.height / 2);
  canvasCtx.rotate((frameCount * Math.PI * 5) / 180);
  canvasCtx.translate(
    -canvasCtx.canvas.width / 2,
    -canvasCtx.canvas.height / 2
  );

  canvasCtx.beginPath();
  canvasCtx.arc(
    canvasCtx.canvas.width / 2,
    canvasCtx.canvas.height / 2,
    Math.round(canvasCtx.canvas.width * 0.05),
    0,
    Math.PI,
    true
  );
  canvasCtx.lineWidth = 5;
  canvasCtx.strokeStyle = "white";
  canvasCtx.stroke();

  canvasCtx.restore();
}

function drawPose(canvasCtx, poseImage, poseLandmarks) {
  let imgH = poseImage.height;
  let imgW = poseImage.width;
  let imgX = canvasCtx.canvas.width / 2 - imgW / 2;
  let imgY = canvasCtx.canvas.height / 2 - imgH / 2;

  canvasCtx.save();

  canvasCtx.clearRect(0, 0, canvasCtx.canvas.width, canvasCtx.canvas.height);

  // Only overwrite existing pixels.
  canvasCtx.globalCompositeOperation = "source-in";
  canvasCtx.fillStyle = "#00FF00";
  canvasCtx.fillRect(0, 0, canvasCtx.canvas.width, canvasCtx.canvas.height);

  // Only overwrite missing pixels.
  canvasCtx.globalCompositeOperation = "destination-atop";
  canvasCtx.drawImage(poseImage, imgX, imgY, imgW, imgH);

  canvasCtx.globalCompositeOperation = "source-over";
  drawConnectors(canvasCtx, poseLandmarks, POSE_CONNECTIONS, {
    color: "#00FF00",
    lineWidth: 4,
  });
  drawLandmarks(canvasCtx, poseLandmarks, {
    color: "#FF0000",
    lineWidth: 2,
  });

  canvasCtx.restore();
}

export { newImage, objectCollision, drawLoading, drawPose };
